import { inject, Injectable, NgModule, provideAppInitializer } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideConfig, provideDefaultConfig, RoutingConfig } from '@spartacus/core';
import { defaultOnNavigateConfig } from '@spartacus/storefront';
import { CustomOnNavigateService } from './custom/routes/custom-on-navigate.service';

@Injectable({
  providedIn: 'root'
})
@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot([], {
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking'
    })
  ],
  providers: [
    provideDefaultConfig(defaultOnNavigateConfig),
    provideConfig(<RoutingConfig>{
      routing: {
        routes: {
          product: {
            paths: ['p/:name/:productCode'],
            paramsMapping: {
              name: 'normalizedName'
            }
          },
          category: {
            paths: ['c/:categoryName/:categoryCode'],
            paramsMapping: {
              categoryCode: 'code',
              categoryName: 'name'
            }
          },
          families: {
            paths: [
              'category/:familyName/:familyCode/families',
              // NOTE: We have to keep this abandoned URL config.
              // Because when we remove it, page request will turn from
              // Correct - https://localhost:9002/spartacus/v2/ohgar/cms/pages?pageType=ContentPage&pageLabelOrId=/families&lang=es&curr=EUR
              // to
              // 404 - https://localhost:9002/spartacus/v2/ohgar/cms/pages?pageType=ContentPage&pageLabelOrId=/category/CP01001/families&lang=es&curr=EUR
              'category/:familyCode/families'
            ],
            paramsMapping: { familyCode: 'code' }
          },
          query: {
            paths: ['/c/:familyCode'],
            paramsMapping: { familyCode: 'code' }
          },
          ticketsCode: {
            paths: ['pedidos-y-devoluciones/:orderCode/:mail'],
            paramsMapping: { orderCode: 'code' }
          },
          myAccountWishlist: {
            paths: ['mi-cuenta/favoritos']
          },
          financePurchases: {
            paths: ['fracciona-tus-compras']
          },
          help: {
            paths: ['ayuda']
          },
          stores: {
            paths: ['nuestras-tiendas']
          },
          register: {
            paths: ['login/registro'],
            protected: false
          },
          forgotPassword: {
            paths: ['login/olvido-contrasena'],
            protected: false,
            authFlow: true
          },
          resetPassword: {
            paths: ['login/cambiar-contrasena'],
            protected: false,
            authFlow: true
          },
          termsAndConditions: {
            paths: ['politica-legal-y-privacidad'],
            protected: false
          },
          ohbar: {
            paths: ['ohbar'],
            protected: false
          },
          checkoutLogin: {
            paths: ['checkout-login']
          },
          checkout: {
            paths: ['checkout']
          },
          checkoutShippingAddress: {
            paths: ['checkout/shipping-address']
          },
          checkoutPaymentDetails: {
            paths: ['checkout/payment-details']
          },
          checkoutPaymentType: {
            paths: ['checkout/payment-type']
          },
          orderConfirmation: {
            paths: ['order-confirmation']
          }
        }
      }
    }),
    provideDefaultConfig({
      customEnableResetViewOnNavigate: {
        active: true,
        ignoreQueryString: true,
        ignoreRoutes: []
      },
      enableResetViewOnNavigate: {
        active: false
      }
    }),
    provideAppInitializer(() => {
      const initializerFn = customOnNavigateFactory(inject(CustomOnNavigateService));
      return initializerFn();
    })
  ]
})
export class AppRoutingModule {}

export function customOnNavigateFactory(onNavigateService: CustomOnNavigateService) {
  const isReady = () => onNavigateService.initializeWithConfig();
  return isReady;
}
